import { render, staticRenderFns } from "./settlementBulk.vue?vue&type=template&id=0805378b&lang=pug&"
import script from "./settlementBulk.vue?vue&type=script&lang=js&"
export * from "./settlementBulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports